import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const dspUpdatePlugin = createPlugin({
  id: 'dsp-update',
  routes: {
    root: rootRouteRef,
  },
});

export const DspUpdatePage = dspUpdatePlugin.provide(
  createRoutableExtension({
    name: 'DspUpdatePage',
    component: () => import('./components').then(m => m.DspDeployment),
    mountPoint: rootRouteRef,
  }),
);
